<template>
  <b-card no-body>
    <b-card-header>
      <b-row
        align-v="center"
        class="w-100 m-0"
      >
        <b-col>
          <h4>
            {{ `ยอดบิลที่ต้องชำระ ${total} รายการ` }}
            
            <b-button
              variant="flat-primary"
              class="btn-icon"
              size="sm"
              @click="fetchData"
            >
              <feather-icon
                icon="RefreshCcwIcon" 
                size="18"
              />
            </b-button>
          </h4>
        </b-col>
        <b-col
          cols="3"
          class="pr-0"
        >
          <v-select
            v-model="selectedStatus"
            label="title"
            :options="statusOptions"
            :clearable="false"
          />
        </b-col>
      </b-row>
      <div />
    </b-card-header>

    <hr class="m-0">
    <b-table
      ref="billSelectableTable"
      :items="dataList"
      :fields="fields"
      :busy="isFetching"
      responsive
      show-empty
      hover
    >
      <template #cell(startDate)="data">
        {{ data.value | date }}
        -
        {{ data.item.endDate | date }}
      </template>
      <template #cell(dueDate)="data">
        {{ data.value | date }}
      </template>
      <template #cell(totalFee)="data">
        {{ data.value | currency }}
      </template>
      <template #cell(commissionRate)="data">
        {{ data.value }}%
      </template>
      <template #cell(totalAmount)="data">
        {{ data.value | currency }}
      </template>
      <template #cell(outstanding)="data">
        <span :class="data.value > 0?'text-danger': ''">
          {{ data.value | currency }}
        </span>
      </template>
      <template #cell(status)="data">
        <b-badge
          :variant="displayStatusColor(data.value)"
        >
          {{ displayStatus(data.value) }}
        </b-badge>
      </template>
      <template #cell(id)="data">
        <b-button
          variant="outline-primary"
          size="sm"
          :to="`/billing/invoices/${data.value}`"
        >
          ดูรายละเอียด
        </b-button>
      </template>
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle" />
        </div>
      </template>
      <template #empty="">
        <div class="my-5">
          <p class="text-center text-muted">
            ไม่มียอดบิลที่ต้องชำระ
          </p>
        </div>
      </template>
    </b-table>
    <!-- pagination -->
    <b-card-footer>
      <b-row class="">
        <b-col md="4">
          <page-limit-select
            :value="limit"
            @update="onLimitChange"
          />
        </b-col>
        <b-col>
          <pagination-input
            :per-page="limit"
            :total="total"
            @update="(val) => (currentPage = val)"
          />
        </b-col>
      </b-row>
    </b-card-footer>
  </b-card>
</template>

<script>
import vSelect from 'vue-select'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'InvoicesList', 
  components: {
    vSelect,
  },
  data() {
    return {
      currentPage: 0,
      selectedLimit: 20,

      selectedStatus: { title: 'ทั้งหมด', value: '0' },
      statusOptions: [
        { title: 'ทั้งหมด', value: '0' },
        { title: 'ค้างชำระ', value: '1' },
        { title: 'ชำระครบแล้ว', value: '2' },
      ],

      search: '', 
      onSearchTimeout: null,

      fields: [
         {
          key: 'ref',
          label: 'เลขที่อ้างอิง',
          thStyle: {
            minWidth: '150px',
          },
        },
        {
          key: 'startDate',
          label: 'รอบที่สรุป',
          thStyle: {
            minWidth: '210px',
          },
        },
        {
          key: 'dueDate',
          label: 'ครบกำหนดชำระ',
          thStyle: {
            minWidth: '150px',
          },
        },
        {
          key: 'totalFee',
          label: 'ค่าธรรมเนียมในรอบ',
          class: 'text-right',
          thStyle: {
            minWidth: '200px',
          },
        },
        {
          key: 'commissionRate',
          label: '% ที่เรียกเก็บ',
          class: 'text-right',
          thStyle: {
            minWidth: '150px',
          },
        },
        {
          key: 'totalAmount',
          label: 'ยอดที่เรียกเก็บ',
          class: 'text-right',
          thStyle: {
            minWidth: '200px',
          },
        },
        {
          key: 'outstanding',
          label: 'ยอดค้างชำระ',
          class: 'text-right',
          thStyle: {
            minWidth: '200px',
          },
        },
        {
          key: 'status',
          label: 'สถานะ',
          thStyle: {
            minWidth: '100px',
          },
        },
        {
          key: 'id',
          label: '',
          thStyle: {
            minWidth: '230px',
          },
          class: 'text-right',
        },
      ],


    }
  },
  computed: {
    ...mapState({
      isFetching: (state) => state.payment.isGettingInvoices,
    }),
    ...mapGetters(['invoices']),
    dataList() {
      return this.invoices.data
    },
    pagination() {
      const { totalItems, perPage } = this.invoices;
      return {
        itemsPerPage: perPage || this.selectedLimit,
        totalItems,
      }
    },
    limit() {
      return this.pagination.itemsPerPage
    },
    total() {
      return this.pagination.totalItems
    },
  },
  watch: { 
    currentPage(val) {
      if (val) {
        this.$addPageToLocation(val)
        this.fetchData()
      }
    },
    selectedStatus(val) {
      if(val.value) {
        this.fetchData()
      }
    },
    search() {
      this.delaySearch()
    },
  },
  created() {
  },
  methods: {
    ...mapActions(['getInvoices', 'saveInvoice']),
    fetchData() {
      this.getInvoices({
        limit: this.selectedLimit,
        skip: this.currentPage,
        search: this.search,
        status: this.selectedStatus.value
      });
    },
    delaySearch() {
      clearTimeout(this.onSearchTimeout)
      this.onSearchTimeout = setTimeout(this.fetchData, 800)
    },
    onLimitChange(limit) {
      if (limit) {
        this.selectedLimit = limit
        this.fetchData()
      }
    },

    displayStatusColor(type) {
       switch (type) {
        case 1:
          return 'light-warning'
        case 2:
          return 'light-success'
        default:
          return 'light-secondary'
      }
    },
    displayStatus(type) {
      switch (type) {
        case 1:
         return 'Pending'
        case 2:
         return 'Complete'
        default:
         return 'type'
      }
    },
  },
}
</script>
 